import { ref } from "vue";

export default function useBookingStoreSlotAvailability(
  baseUrl: string,
  lang: string
) {
  const isLoading = ref(false);

  const getAllowedDates = async (
    productId: number|string,
    storeId: number|string,
    size: string,
    color: string,
    year: number,
    month: number,
  ) => {
    // console.log('getAllowedDates');

    const searchParams = new URLSearchParams()
    searchParams.append('lang', lang);
    searchParams.append('product', productId as string);
    searchParams.append('store', storeId as string);
    searchParams.append('size', size);
    searchParams.append('color', color);
    searchParams.append('year', year.toString());
    searchParams.append('month', month.toString());

    // define allowedDates as an array of Date objects
    let allowedDates = <Date[]>[];

    isLoading.value = true;
    try {
      const response = await fetch(`${baseUrl}/availability/store/dates?${searchParams.toString()}`);
      const data = await response.json();
      allowedDates = data.data
        .filter((date) => {
          return date.slots.length > 0
            && date.slots.some((slot) => slot.availableEquipments.length > 0);
        })
        .map((date) => new Date(date.date));
    } catch (e) {
      throw e;
    } finally {
      isLoading.value = false;
    }

    return allowedDates;
  }

  const getAvailableSlots = async (
    productId: number|string,
    storeId: number|string,
    size: string|null,
    color: string|null,
    year: number,
    month: number,
    day: number,
  ) => {
    if (!productId) {
      throw new Error('Missing required parameter: productId');
    }
    if (!storeId) {
      throw new Error('Missing required parameter: storeId');
    }
    if (!year) {
      throw new Error('Missing required parameter: year');
    }
    if (!month) {
      throw new Error('Missing required parameter: month');
    }
    if (!day) {
      throw new Error('Missing required parameter: day');
    }

    const searchParams = new URLSearchParams()
    searchParams.append('lang', lang);
    searchParams.append('product', productId as string);
    searchParams.append('store', storeId as string);
    searchParams.append('size', size ? size.toString() : '');
    searchParams.append('color', color ? color.toString() : '');
    searchParams.append('year', year.toString());
    searchParams.append('month', month.toString());
    searchParams.append('day', day.toString());

    let allowedSlots = [];

    isLoading.value = true;
    try {
      const response = await fetch(`${baseUrl}/availability/store/slots?${searchParams.toString()}`);
      const data = await response.json();
      allowedSlots = data.data.slots;
    } catch (e) {
      throw e;
    } finally {
      isLoading.value = false;
    }

    return allowedSlots;
  }

  return {
    isLoading,
    getAllowedDates,
    getAvailableSlots,
  }
}